import React, { Component } from 'react';
import { Modal } from 'antd'
class AuthenticationModal extends Component {
  constructor(props) {
    super(props);
  }
  toAuthentication =() => {
    this.props.toAuthentication()
  }
  render() {
    const {content, isShowButton, visible, notAuthority, status, statusReason} = this.props
    return (
      <Modal title="身份认证" visible={visible} footer={isShowButton} closable={false}>
        <div style={{textAlign: 'center'}}>
        {content}
        <br/>
        {status === 3&&
          <span>未通过原因：{statusReason}</span>
        }
        {notAuthority&&
          <p style={{color: 'red'}}>*您没有权限访问，请联系管理员！</p>
        }
        </div>
      </Modal>
    )
  }
}

export default AuthenticationModal;